import AnalyticsModel from '../models';

type Hourly = 'hourly';
type Daily = 'daily';
type Weekly = 'weekly';
type Monthly = 'monthly';

type Desktop = 'desktop';
type Mobile = 'mobile';
type All = 'all';
type Tablet = 'tablet';

export type TDevice = Desktop | Mobile | All | Tablet;

export type TResolution = Hourly | Daily | Weekly | Monthly;

export type TChart = 'page_views' | 'comments' | 'likes' | 'registrations' | 'all';

export type TAnalytics = AnalyticsModel;

export type TAnalyticsParams = {
  device: TDevice;
  resolution: TResolution;
  fromDay: number;
  toDay: number;
  type?: TChart;
  spotId?: string;
};

export interface AnalyticsSecondaryTabItem {
  label: string;
  routeName: string;
  navParams: { spot_id: string };
}

export enum AnalyticsSecondaryTab {
  Overview = 'overview',
  Monetization = 'monetization',
  Engagement = 'engagement',
  Revenue = 'revenue',
  Moderation = 'moderation'
}
